/**

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import colors from "assets/theme/base/colors";

//theme colors
const { info } = colors;
const { charts } = info;

export const radarChartOptions = {
  chart: {
    type: "radar",
    toolbar: {
      show: false,
    },
  },
  labels: ["Pan-India", "North", "East", "South", "West"],
  colors: [charts[100], charts[400]],
  chart: {
    width: "100%",
  },
  states: {
    hover: {
      filter: {
        type: "none",
      },
    },
  },
  plotOptions: {
    radar: {
      size: undefined,
      offsetX: 0,
      offsetY: 0,
      polygons: {
        strokeColors: "#56577A",
        strokeWidth: 1,
        connectorColors: "#56577A",
        fill: {
          colors: undefined,
        },
      },
    },
  },
  yaxis: {
    show: false,
  },
  markers: {
    show: true,
    enabled: true,
  },
  xaxis: {
    labels: {
      style: {
        fontSize: "14px",
        color: "#8F9BBA",
      },
    },
  },
  stroke: {
    show: true,
    width: 2,
    colors: [charts[100], charts[400]],
    dashArray: 0,
  },
  legend: {
    show: true,
    labels: {
      colors: "text",
    },
  },
  dataLabels: {
    enabled: true
  },
  fill: {
    colors: [charts[100], charts[400]],
    type: "solid",
  },
  tooltip: {
    enabled: true,
    theme: "dark",
  },
};

export const radarChartData = [
  {
    name: "Freight Index",
    data: [0,0,0,0,0],
  },
  {
    name: "Fuel price",
    data: [0,0,0,0,0],
  },
];
